<template>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="font-size:24px;" class="headline">Campaigns Summary</v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="campaign-summary-total">
            <span class="campaign-summary-total__count">({{ totalCount }})</span>
            <span>Total</span>
          </div>
        </v-toolbar>
        <v-list two-line subheader color="background-white">
          <v-list-item v-for="(item, i) in summaryList" @click="changeRoute(item)" :key="i">
            <v-list-item-avatar>
              <v-icon>{{item.aIcon}}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="title">{{item.value}}</span>
                {{item.value >= 2 ? 'Campaigns' : 'Campaign'}}
              </v-list-item-title>
              <v-list-item-subtitle>{{item.title}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon ripple>
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';
export default {
  props: {},
  data() {
    return {
      totalCount: 0,
      summaryList: [
        {
          status: config.campaignStatus.DRAFT,
          aIcon: 'mdi-file-document-edit',
          title: 'Draft',
          value: 0,
          path: `${this.getPath()}/draft`
        },
        {
          status: config.campaignStatus.PENDING_CLIENT_APPROVAL,
          aIcon: 'mdi-file-clock',
          title: 'Pending for Approval',
          value: 0,
          path: `${this.getPath()}/pending_approval`
        },
        {
          status: config.campaignStatus.PAIRING_INFLUENCER,
          aIcon: 'mdi-account-switch',
          title: 'Pairing',
          value: 0,
          path: `${this.getPath()}/pairing_influencer`
        },
        {
          status: config.campaignStatus.ONGOING,
          aIcon: 'mdi-file-check',
          title: 'Ongoing',
          value: 0,
          path: `${this.getPath()}/on_going`
        },
        {
          status: config.campaignStatus.COMPLETE,
          aIcon: 'mdi-zip-box-outline',
          title: 'Completed',
          value: 0,
          path: `${this.getPath()}/completed`
        },
        {
          status: 7,
          aIcon: 'mdi-archive',
          title: 'Archived',
          value: 0,
          path: `${this.getPath()}/archive`
        }
        // {
        //   status: config.postStatus.COMPLETE,
        //   aIcon: 'archive',
        //   title: 'Completed Posts',
        //   value: 0,
        //   path: '/posts/completed'
        // }
      ]
    };
  },
  computed: {
    ...mapState({
      campaignsCount: state => state.campaign.campaignsCount
    })
  },
  methods: {
    changeRoute(item) {
      this.$router.push({ path: item.path });
    },
    getPath() {
      return '/campaigns';
    },
    async fetchCampaigns() {
      let statuses = config.campaignStatus
      statuses['ARCHIVE'] = 7
      this.totalCount = 0
      for (var key of Object.keys(statuses)) {
        let status = statuses[key];
        await this.$store.dispatch('campaign/getCampaignsCountByStatus', {
          status,
          archive: status === 7 || false
        })
        if (this.campaignsCount) {
          this.summaryList.forEach(item => {
            if (item.status === status) {
              item.value = Number(this.campaignsCount)
              this.totalCount += Number(this.campaignsCount)
            }
          });
        }
      }
    }
  },
  mounted() {
    this.fetchCampaigns();
  }
};
</script>
<style>
.background-white {
  background-color: white !important;
}

.campaign-summary-total {
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
}

.campaign-summary-total__count {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// CampaignSummary.vue?452a2ad8